import { render, staticRenderFns } from "./trainer-list.vue?vue&type=template&id=6303e37c"
import script from "./trainer-list.vue?vue&type=script&lang=js"
export * from "./trainer-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports